arrayUtil = exports

arrayUtil.copySort = (arr, comparator = undefined) ->
    # return a sorted copy of the array, rather than modifying the original array
    return $.merge([], arr).sort(comparator)


arrayUtil.closest = (arr, goal = 0) ->
    closest = null
    minDiff = null
    for el in arr
        n = parseInt(el)
        d = Math.abs(n - goal)
        if not closest? or d < minDiff or (d is minDiff and n > closest)
            closest = n
            minDiff = d

    return closest


arrayUtil.insertSorted = (arr, item, comparator) ->
    # Insert an element into a sorted array so that it remains sorted.
    # NOTE: Supplying a comparator is highly recommended (e.g. strnatcasecmp)
    if not comparator?
        # emulate the default .sort() behavior, which does string comparisons
        comparator = (a, b) ->
            a = String(a) if typeof a isnt 'string'
            b = String(b) if typeof b isnt 'string'
            if a > b then return 1
            if a < b then return -1
            return 0

    # Do a binary search to determine the index at which to insert the item.
    index = do (arr, item) ->
        min = 0

        # Don't do `length - 1` because if the item should go at the end, we
        # want it to actually be added at the end, not before the last item.
        max = arr.length

        # Set the initial index outside the loop, in case the array is empty.
        index = Math.floor((min + max) / 2)

        # If max and min are the same, we already have the index we want.
        while (max > min)
            result = comparator(item, arr[index])
            if result < 0
                # Don't do `index - 1`. This may look like it will repeat some
                # comparisons but it actually won't, because we take the floor
                # of the midpoint and we don't do a comparison if min is max.
                max = index
            else
                # If the item is higher or the same, move on the next index.
                min = index + 1

            # Get the index based on the new min and max. If they're the same,
            # then we have the final index and we'll break out of the loop.
            index = Math.floor((min + max) / 2)

        return index

    # Now we can go ahead and insert the item at that index. If the index
    # doesn't exist yet (we're inserting at the end of the array), .splice()
    # will create it.
    arr.splice(index, 0, item)


arrayUtil.joinPretty = (arr, join_text = 'and', empty_text = 'nothing') ->
    switch arr.length
        when 0
            return empty_text
        when 1
            return arr[0]
        when 2
            return "#{arr[0]} #{join_text} #{arr[1]}"
        else
            # I've said it before and I'll say it again, I <3 CoffeeScript!
            [most..., last] = arr
            return "#{most.join(', ')}, #{join_text} #{last}"
